const PREFIXES = [
	'acoustic',
	'electric',
	'strum',
	'pick',
	'harmony',
	'chord',
	'rock',
	'blues',
	'metal',
	'jazz',
	'solo',
	'amp',
	'tone',
	'classic',
	'vintage',
	'resonator',
	'folk',
	'soul',
	'wild',
	'smooth',
	'dread',
	'echo',
	'shadow',
	'legend',
	'adventure',
	'melody',
	'rhythm',
	'passion',
	'serenade',
	'express',
	'echo',
	'vibrato',
	'shred',
	'crunch',
	'twang',
	'sustain',
	'groove',
	'fusion',
	'delta',
	'acoustic-electric',
	'screaming',
	'funky',
	'psychedelic',
	'ambient',
	'alternative',
	'progressive',
	'heavy',
	'blazing',
	'mellow',
	'jumbo',
	'solid-body',
	'semi-hollow',
	'custom',
	'vintage-inspired',
	'handcrafted',
	'artisan',
	'cutaway',
	'archtop',
	'signature',
	'limited',
	'special',
	'travel',
	'resonance',
	'vibrance',
	'fire',
	'zen',
	'soulful',
	'grand',
	'platinum',
	'silver',
	'copper',
	'bronze',
	'pioneer',
	'ultimate',
	'innovative',
	'spiritual',
	'divine',
	'cosmic',
	'stellar',
	'celestial',
	'mystic',
	'ethereal',
	'profound',
	'timeless',
	'transcendental',
	'majestic',
	'empyrean',
	'enchanted',
	'radiant',
	'dreamy',
	'serene',
	'eternal',
	'ancient',
	'enchanted',
	'infinite',
	'mesmerizing',
	'whispering',
	'cosmic',
	'luminous',
	'sacred',
	'harmonic',
	'triumphant',
	'captivating',
	'illuminating',
	'paradise',
	'hypnotic',
  ]
  
  const WORD_SUFFIXES = [
	'strum',
	'tune',
	'riff',
	'wave',
	'tone',
	'beat',
	'groove',
	'blues',
	'rock',
	'jazz',
	'soul',
	'magic',
	'vibe',
	'sound',
	'echo',
	'legend',
	'serenade',
	'jam',
	'harmony',
	'melody',
	'rhythm',
	'passion',
	'sensation',
	'player',
	'strummer',
	'maker',
	'shredder',
	'artist',
	'hero',
	'pro',
	'king',
	'slinger',
	'wizard',
	'captain',
	'star',
	'maestro',
	'virtuoso',
	'novice',
	'wizard',
	'sorcerer',
	'conductor',
	'maiden',
	'prince',
	'princess',
	'ninja',
	'samurai',
	'viking',
	'dragon',
	'dreamer',
	'explorer',
	'sage',
	'warrior',
	'poet',
	'minstrel',
	'bard',
	'sorceress',
	'goddess',
	'heroine',
	'legendary',
	'wanderer',
	'traveler',
	'mystic',
	'nomad',
	'oracle',
	'alchemist',
	'siren',
	'muse',
	'philosopher',
	'mystagogue',
	'visionary',
	'prophet',
	'chronicler',
	'ethereal',
	'magician',
	'shaman',
	'explorer',
	'adventurer',
  ]
  
  // Actual suffixes (not just words); ranks lower
  const ACTUAL_SUFFIXES = [
	'caster',
	'master',
	'strat',
	'tele',
	'bass',
	'lite',
	'wood',
	'sound',
	'burst',
	'gold',
	'silver',
	'platinum',
	'custom',
	'deluxe',
	'signature',
	'vintage',
	'classic',
	'modern',
	'artist',
	'edition',
	'select',
	'elite',
	'ultimate',
	'pro',
	'standard',
	'special',
	'deluxe',
	'premium',
	'vibe',
	'fusion',
	'spirit',
	'heritage',
	'retro',
	'icon',
	'supreme',
	'dream',
	'fantasy',
	'paradise',
	'ocean',
	'wildlife',
	'zenith',
	'journey',
	'voyager',
	'starlight',
	'twilight',
	'admiral',
	'voyage',
	'trek',
	'phantom',
	'phantasm',
	'essence',
	'zenith',
	'apex',
	'elixir',
	'equinox',
	'nova',
	'equilibrium',
	'nirvana',
	'serenity',
	'triumph',
	'harmony',
	'epiphany',
	'illumination',
	'crescendo',
	'cosmos',
	'paragon',
	'serendipity',
	'reverie',
	'euphoria',
	'solstice',
	'allegro',
	'allegiance',
	'melancholy',
	'elegance',
	'alchemy',
	'sovereign',
	'ascension',
  ]
  
  const ADDITIONAL_SUFFIXES = [
	'sunburst',
	'moonbeam',
	'starlight',
	'firebird',
	'phoenix',
	'thunder',
	'lightning',
	'wildfire',
	'nightfall',
	'daydream',
	'dreamscape',
	'celestial',
	'zenith',
	'paragon',
	'tempest',
	'pioneer',
	'horizon',
	'plainsman',
	'frontier',
	'outlaw',
	'trailblazer',
	'explorer',
	'adventurer',
	'wanderer',
	'chronicle',
	'quest',
	'legacy',
	'heritage',
	'legendary',
	'genesis',
	'eternity',
	'odyssey',
	'destiny',
	'fate',
	'journey',
	'adventure',
	'saga',
	'epic',
	'tale',
	'myth',
	'sunset',
	'moonlight',
	'mystique',
	'nexus',
	'equator',
	'cascade',
	'cascade',
	'echoes',
	'embrace',
	'evolution',
	'panorama',
	'mirage',
	'tundra',
	'valhalla',
	'triumvirate',
	'catalyst',
	'melody',
	'sonnet',
	'sonata',
	'harbor',
	'boulevard',
	'grotto',
	'canvas',
  ]
  
  const SUFFIXES = WORD_SUFFIXES.concat(ACTUAL_SUFFIXES).concat(ADDITIONAL_SUFFIXES)
  
  module.exports = {
	PREFIXES,
	SUFFIXES,
	WORD_SUFFIXES,
	ACTUAL_SUFFIXES
  }
  